// <copyright file="environment.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 10/09/2025 by Naziya Firdos
// Updated: 02/16/2026 - Added dynamic environment resolution support
// </copyright>

export const environment = {
  production: false,
  translation: {
    prefix: "./assets/common/translations/",
    suffix: ".json",
    fallbackLang: "en-US",
    lang: "en-US"
  },
  emailDomainPrefix: "bd",
  emailDomainSuffix: ".com",
  contactPhonNumber: "1-800-822-9837",
  contactEmail: "msu_support@bd.com",
  appEndPointVersion: "v1",
  browserRestriction: {
    enabled: true,
    minimumChromeVersion: 145
  },
  webAppVersion: "E1.0.6.1-DEV",
  versionUpdatedDate: "03/23/2026"
};
